package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.ast.ElementAst
import top.wcpe.allincore.dsl.compiler.ast.ElementWalk
import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.ast.ScreenAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.diag.DslError

class ShaderLayerProgramSymbolPass(private val diag: DiagnosticCollector, private val knownPrograms: Set<String>) {

    fun check(screen: ScreenAst) {
        if (knownPrograms.isEmpty()) {
            return
        }
        checkElement(screen.root)
    }

    private fun checkElement(element: ElementAst) {
        for (modifier in element.modifiers) {
            if (modifier.kind == "shaderLayer") {
                val program = modifier.fields.firstOrNull { it.name == "program" }
                val literal = program?.value as? ExprAst.Literal.StringLit
                if (program != null && literal != null && literal.value !in knownPrograms) {
                    diag.error(DslError.AUI_V2_SHADER_LAYER_PROGRAM_UNRESOLVED, program.position, literal.value)
                }
            }
        }
        for (child in ElementWalk.directDescendants(element)) {
            checkElement(child)
        }
    }
}
